import { Stack, StackProps } from "@mui/material";

type PageContentContainerProps = StackProps & {};
export const PageContentContainer = (props: PageContentContainerProps) => {
  return (
    <Stack
      {...props}
      flexGrow={1}
      sx={{ ...props.sx, overflow: "hidden", minHeight: "160px" }}
    >
      {props.children}
    </Stack>
  );
};

export const PageContentScrollableContainer = (
  props: PageContentContainerProps
) => {
  return (
    <Stack
      flexGrow={1}
      sx={{
        overflow: "auto",
        minHeight: "160px",
        paddingBottom: "10px",
      }}
      {...props}
    >
      {props.children}
    </Stack>
  );
};
